// extracted by mini-css-extract-plugin
module.exports = {"initialButton":"styles_initialButton__s9O_W","block":"styles_block__dNMhj","fadeIn":"styles_fadeIn__NhS_y","nonBlock":"styles_nonBlock__9G9SN","fadeOut":"styles_fadeOut__EayXv"};